/* Native controls work without JavaScript and after Theme Editor reloads. */
if (!customElements.get('process-video')) {
  customElements.define('process-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        if (this.motion.matches) this.video.pause();
      };
      this.motion.addEventListener('change', this.onMotionChange);
      if (this.hasAttribute('data-autoplay') && !this.motion.matches) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            if (!this.motion.matches) this.video.play().catch(() => {});
          }
        });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.onMotionChange);
      this.video?.pause();
    }
  });
}
